import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Radio } from 'semantic-ui-react';

import '../css/RadioWithOptionalInfoIcon.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

const RadioWithOptionalInfoIcon = observer((props = {}) => {
  const {
    _id,
    checked,
    disabled,
    label,
    onChange,
    popupOptions = {},
    t,
    toggle = true,
  } = props;

  const { /* managers */ } = useContext(MobXProviderContext);

  const InfoIcon = SatCoreComponent('InfoIcon');

  const tooltipKey = `tooltip${_id}`;
  const tooltip = props.tooltip || t(tooltipKey);

  const radioJsx = (
    <Radio
      checked={checked}
      disabled={disabled}
      label={label}
      onChange={onChange}
      toggle={toggle} />
  );
  if (!tooltip) {
    return radioJsx;
  } else {
    return (
      <div className={`RadioWithOptionalInfoIcon radio-option-parent radio-option-parent-${_id}`}>
        <div className={`radio-option radio-option-${_id}`}>
          {radioJsx}
        </div>
        <div className={`info-icon-parent info-icon-parent-${tooltipKey}`}>
          <InfoIcon className={`InfoIcon-${tooltipKey} RadioInfoIcon`}
            popupOptions={{ content: tooltip, on: 'click', ...(popupOptions || {}) }} useWhiteInfoIcon={false} />
        </div>
      </div>
    );
  }
});
export default RadioWithOptionalInfoIcon;

SatCoreRegister('RadioWithOptionalInfoIcon', RadioWithOptionalInfoIcon);
